import { render, staticRenderFns } from "./layout-product-card.vue?vue&type=template&id=7c6efd4a&scoped=true&"
import script from "./layout-product-card.vue?vue&type=script&lang=js&"
export * from "./layout-product-card.vue?vue&type=script&lang=js&"
import style0 from "./layout-product-card.vue?vue&type=style&index=0&id=7c6efd4a&lang=scss&scoped=true&"
import style1 from "./layout-product-card.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6efd4a",
  null
  
)

export default component.exports